/* ==========================================================================
   FAQ Section
   File: assets/faq-section.js
   Filters FAQ items by category chip. Supports multiple section instances on
   the same page — each <section data-faq-section> is initialised once.
   ========================================================================== */

(function () {
  'use strict';

  var ALL_SLUG = 'all';

  /* Normalise a slug for case- and whitespace-insensitive comparison. */
  function normalise(value) {
    return String(value || '').trim().toLowerCase();
  }

  function init(root) {
    if (!root || root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    var chips = root.querySelectorAll('[data-faq-chip]');
    var items = root.querySelectorAll('[data-faq-item]');
    var emptyState = root.querySelector('[data-faq-empty]');
    if (!chips.length) return;

    function applyFilter(slug) {
      var target = normalise(slug);
      var visibleCount = 0;

      items.forEach(function (item) {
        var category = normalise(item.getAttribute('data-faq-category'));
        var match = target === ALL_SLUG || category === '' || category === target;
        if (match) {
          item.removeAttribute('hidden');
          visibleCount++;
        } else {
          item.setAttribute('hidden', '');
          /* Collapse any open item that's been filtered out so the next
             time the user opens it the state is predictable. */
          if (item.hasAttribute('open')) item.removeAttribute('open');
        }
      });

      chips.forEach(function (chip) {
        var pressed = normalise(chip.getAttribute('data-faq-chip')) === target;
        chip.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });

      if (emptyState) {
        if (visibleCount === 0) emptyState.removeAttribute('hidden');
        else emptyState.setAttribute('hidden', '');
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        applyFilter(chip.getAttribute('data-faq-chip'));
      });
    });

    /* Honour an initial active chip if one is marked in the DOM, else
       fall back to the first chip. */
    var initial = root.querySelector('[data-faq-chip][aria-pressed="true"]')
      || chips[0];
    applyFilter(initial.getAttribute('data-faq-chip'));
  }

  function bootstrap() {
    document.querySelectorAll('[data-faq-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Re-initialise after a Shopify section reload in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-faq-section]');
    if (root) init(root);
  });
})();
